import copyToClipboard from './copy-to-clipboard-func'

const applyShareBtnHandling = (shareBtnWrapperElements, url) => {
  let currentUrl = url || window.location.href;

  shareBtnWrapperElements.forEach((itm) => {
    const shareBtn = itm.querySelector('.share-btn');
    const copyBtn = itm.querySelector('.share-btn-wrapper__copy-link-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        if (navigator.share && window.innerWidth < 768) {
          await navigator.share({
            url: currentUrl,
          });
        } else {
          itm.classList.toggle('share-btn-wrapper_popup');
        }
        itm.querySelectorAll('.share-btn-wrapper__item').forEach((item) => {
          item.addEventListener('click', () => {
            itm.classList.remove('share-btn-wrapper_popup');
            const shareUrlElement = document.querySelector('.content-clipboard');
            if (shareUrlElement) {
              copyToClipboard(currentUrl)
            }
          });
        });
      })
    }
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        copyToClipboard(currentUrl);
        copyBtn.classList.add('share-btn-wrapper__copy-link-btn_active');
        setTimeout(() => {
          copyBtn.classList.remove('share-btn-wrapper__copy-link-btn_active');
        }, 2000);
      })
    }
  });
}
window.applyShareBtnHandling = applyShareBtnHandling;

document.addEventListener('DOMContentLoaded', function () {
  const shareBtnWrapperElements = document.querySelectorAll('.share-btn-wrapper');
  applyShareBtnHandling(shareBtnWrapperElements, window.location.href);
});